import React, { Dispatch, useEffect } from "react";
import { useTranslation } from "../i18n";
import "./Onboarding.css";
import "./Sidebar.css";

export type OnboardingType = {
  setShowOnboarding: Dispatch<boolean>;
};

export default function Onboarding({ setShowOnboarding }: OnboardingType) {
  const t = useTranslation();

  useEffect(() => {
    const handleKeyUp = (event: KeyboardEvent) => {
        if (event.key.toLowerCase() === 'escape') {
            event.preventDefault();
            setShowOnboarding(false);
        }
    };
    document.addEventListener('keyup', handleKeyUp);
    return () => {
        document.removeEventListener('keyup', handleKeyUp);
    }
  }, [setShowOnboarding]);

  return (
    <div className="floatingContainer">
      <div className="onboardingWrapper">
        <button className="exit" onClick={() => setShowOnboarding(false)}>
          X
        </button>
        <h2 className="onboardingTitle">{t("Onboarding.Title")}</h2>
        <div className="bodyText">
          <p>
            {t("Onboarding.Paragraph.1")} <br /><br />

            {t("Onboarding.Paragraph.2")}{" "}
            <a href="https://tally.so/r/nPdeqx">{t("Onboarding.Paragraph.3")}</a> <br />
          </p>
          <p>
            <strong>{t("Onboarding.Subtitle.1")}</strong>
            <br />
            <br />
            🗺 <strong>{t("Onboarding.EmphasisedWord.1")}</strong> {t("Onboarding.Paragraph.5")}
            <br />
            <br /> 📍 <strong>{t("Onboarding.EmphasisedWord.2")}</strong> {t("Onboarding.Paragraph.6")}
          </p>
          <p>
            <strong>{t("Onboarding.Subtitle.2")}</strong> <br />
            {t("Onboarding.Paragraph.7")} {" "}
            <br />
            <br />
            🌎 <strong>{t("Onboarding.EmphasisedWord.3")}</strong> <br /> 
            🟦 {t("Onboarding.Paragraph.8")}
            <br />
            <br />
            🟨 {t("Onboarding.Paragraph.9")}
            <br />
            <br />
            📏 {t("Onboarding.Paragraph.10")}
            <br />
            <br />
            🎣 {t("Onboarding.Paragraph.11")}
            <br />
            <br />
            🚢 {t("Onboarding.Paragraph.12")}
            <br />
            <br />
            🏭 {t("Onboarding.Paragraph.13")}
            
          </p>
        </div>
        <div className="okButtonContainer">
            <button
            className="darkButton okButton"
            onClick={() => setShowOnboarding(false)}
            >{`OK`}</button>
        </div>
      </div>
    </div>
  );
}
